import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', short: 'EN', label: 'English' },
  { code: 'pl', short: 'PL', label: 'Polski' },
  { code: 'es', short: 'ES', label: 'Español' },
  { code: 'fr', short: 'FR', label: 'Français' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const current = languages.find((l) => l.code === i18n.language) ?? languages[0];

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1.5 rounded-full border border-stone-200 bg-white px-3 py-1.5 text-sm font-medium text-stone-700 hover:bg-stone-50 whitespace-nowrap cursor-pointer"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <i className="ri-global-line w-4 h-4 flex items-center justify-center" aria-hidden="true" />
        <span>{current.short}</span>
        <i className="ri-arrow-down-s-line w-4 h-4 flex items-center justify-center text-xs" aria-hidden="true" />
      </button>

      {open && (
        <ul
          role="listbox"
          className="absolute right-0 z-50 mt-2 w-40 overflow-hidden rounded-lg border border-stone-200 bg-white py-1"
        >
          {languages.map((lang) => (
            <li key={lang.code}>
              <button
                type="button"
                onClick={() => {
                  i18n.changeLanguage(lang.code);
                  setOpen(false);
                }}
                className={`flex w-full items-center justify-between px-3 py-2 text-left text-sm hover:bg-stone-50 whitespace-nowrap cursor-pointer ${
                  lang.code === current.code ? 'font-semibold text-emerald-700' : 'text-stone-700'
                }`}
              >
                <span>{lang.label}</span>
                {lang.code === current.code && (
                  <i className="ri-check-line w-4 h-4 flex items-center justify-center" aria-hidden="true" />
                )}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}